import { url } from "@/event/url/url"

const hostname = url.host
const parts = hostname.split('.')
const numPart = parts.length

export const arrayUrlTest = ['localhost:5173', 'localhost:4173', 'dev.eronor.eu', 'menuboard.fr']

export const URL_BACK: string = (() => {
    if (arrayUrlTest.includes(url.host)) {
        return 'back.eronor.eu'
    } else {
        return 'back.abikebab.fr'
    }

    // return "default.backend.com";
})()

export const URL_IMAGE: string = `https://${URL_BACK}/`

export function getUrlBack(): string {
    return `https://${URL_BACK}/`
}

export function isAllowedHost(): boolean {
    const host = window.location.host   // includes port
    const hostname = window.location.hostname // no port

    const urlIrfan = 'irfan.eronor.com'
    return arrayUrlTest.includes(host) || arrayUrlTest.includes(hostname) || urlIrfan.includes(hostname)
}